export enum LISTING_ATTRIBUTE_NAME {
  FOR_SALE_BY = 'forsaleby',
}

export enum LISTING_ATTRIBUTE_VALUE {
  DEALER = 'delr',
  OWNER = 'ownr',
}
